import React, { Fragment, useEffect } from "react";
import { useState } from "react";
import API from "../../services/api";
import { useNavigate } from "react-router-dom";
import ScrollContainer from "react-indiana-drag-scroll";
import NoDataFound from "../../shared/NoDataFound";
import TableLoader from "../../shared/TableLoader";
import { useDispatch, useSelector } from "react-redux";
import { SetComponentId } from "../../redux/counterSlice";
import mikeSvg from "../../assets/images/campaign.svg";
import closeSvg from "../../assets/images/uncheck.svg";
import Select from 'react-select'
import config from "../../config";
import {roles, alphabets, BrandsTypes} from "../../utils/constants";
import CryptoJS from "crypto-js";
import { SlTabGroup, SlTab, SlIcon } from "@shoelace-style/shoelace/dist/react";
import { Toast } from "../../shared/Toast";
import "./MyPerformance.scss";


function MyPerfomance() {
  const navigate = useNavigate();
  const dispatch = useDispatch();
  dispatch(SetComponentId(33));
  const salesUsersList = useSelector((state) => state.Head.subordinates);
  const allowedNewUserTypes = [...new Set(salesUsersList.map(item => item.new_user_type))]
  const [tempSalesUsersList, setTempSalesUsersList] = useState(salesUsersList)
  const [currentyearPerfomance, setcurrentyearPerfomance] = useState([]);
  const [previousyearPerfomance, setpreviousyearPerfomance] = useState([]);

  const [selectedList, setSelectedList] = useState(localStorage.getItem("selectedSalesList") && salesUsersList?.length > 1 &&
    JSON.parse(localStorage.getItem("selectedSalesList")).length
    ? salesUsersList.filter((item) =>
        JSON.parse(localStorage.getItem("selectedSalesList"))?.includes(
          item.value
        )
      )
    : salesUsersList?.length > 1 ? [] : []);
  const [salesPerson_id, setSalesPerson_id] = useState(
    salesUsersList?.length > 1 ? localStorage.getItem("selectedSalesList") &&
      JSON.parse(localStorage.getItem("selectedSalesList")).length
      ? salesUsersList.filter((item) =>
          JSON.parse(localStorage.getItem("selectedSalesList"))?.includes(
            item.value
          )
        )[0]?.value || -1
      : salesUsersList[0]?.value
    : -1);

  const [loader, setLoader] = useState(false);
  const currentYear = new Date().getFullYear();
  const previousYear = currentYear - 1;


  const [filterActiveLetters, setFilterActiveLetters] = useState([...new Set(
        salesUsersList.map((item) =>{
          return item?.label[0]?.toUpperCase()
        }
        ).sort()
      )]);
  const [searchFilter, setSearchFilter] = useState('')
const [showUsersFilter, setShowUsersFilter] = useState( false
    // JSON.parse(localStorage.getItem("selectedSalesList"))?.length ? false : salesUsersList?.length > 1 ?  true : false
  )
  const [newUserTypeInfilter, setNewUserTypeInfilter] = useState(0)
  const fetchPerfomace = async () => {
    setLoader(true);
    try {
      let res = await API({
        url: "/effort_analysis/getMyPerfomance",
        method: "POST",
        responseType: "json",
        data: {
          date:getYearTimeStamp(),
          sales_id: salesPerson_id !== -1 ? salesPerson_id : undefined,
        },
      });
      if (res.code === 200) {
        setcurrentyearPerfomance(res.data?.currentYear)
        setpreviousyearPerfomance(res.data?.previousYear)
      }
    } catch (error) {
      console.error(error)
      if (error.response.status === 401) navigate("/");
    } finally {
      setLoader(false);
    }
  };
  const onSlSalesChange = (selected) => {
    setSelectedList(
      selected || []
    );
    localStorage.setItem("selectedSalesList", JSON.stringify(selected.map(item => item.value)))
    // if(salesPerson_id !== -1){
      setSalesPerson_id( salesUsersList?.length > 1
        ? selected[selected.length - 1]?.value || -1
        : -1)
        document
        .getElementById(`${selected[selected.length - 1]?.value}`)
        .scrollIntoView({ behavior: "smooth" });
    // } 
  };
  const getYearTimeStamp = () =>{
    const currentDate = new Date();

    // Extract the year from the current date
    const currentYear = currentDate.getFullYear();
    
    // Create a new date object representing the first day of the year
    const firstDayOfYear = new Date(currentYear, 0, 1, 0, 0, 0, 0);
    
    // Get the timestamp in milliseconds
    const firstTimestampOfYear = firstDayOfYear.getTime();
    return Math.round(firstTimestampOfYear / 1000)
  }

  function formatAmount(amount) {
    amount = parseFloat(amount)
    if (amount >= 10000000) {
      return (amount / 10000000).toFixed(2) + " Cr";
    } else if (amount >= 100000) {
      return (amount / 100000).toFixed(2) + " L";
    } else {
      if(!amount) {
        amount = 0
      }
      return amount?.toFixed(2);
    }
  }
  function calculatePercentage(target, reached) {
    if(isNaN(target) || isNaN(reached)) {
      return 0;
    }
    if (parseInt(target) === 0 || parseInt(reached) === 0) {
      return 0;
    }
    const percentage = (reached / target) * 100;
    const percentageInteger = parseInt(percentage.toFixed(2).replace(".", ""));
    const formattedPercentage =
      percentageInteger % 100 === 0
        ? (percentageInteger / 100).toString()
        : percentage.toFixed(2);
    return formattedPercentage;
  }
  const salesTabChange = async (sales_id) => {
    setcurrentyearPerfomance([]);
    setpreviousyearPerfomance([]);
    setSalesPerson_id(sales_id)
  };
  useEffect(() => {
    fetchPerfomace();
  }, [salesPerson_id]);

  const scrollToSection = (id) => {
    document?.getElementById(id)?.scrollIntoView({ behavior: "smooth" });
  };
  const handleRemove = (event) => {
    const sales_person_id = event;
    let tempArray = selectedList.filter(item => item.value !== +sales_person_id)
    setSelectedList(tempArray)
    let slideToId = salesPerson_id
    if(+sales_person_id === salesPerson_id){
      setSalesPerson_id(tempArray[0].value)
      slideToId = tempArray[0].value
    }
    localStorage.setItem("selectedSalesList", JSON.stringify(tempArray.map(item => item.value)))
    document?.getElementById(slideToId)?.scrollIntoView({ behavior: "smooth" });
  }

  const handleNewUsrTypChange = (new_user_type) => {
    try {
      setNewUserTypeInfilter(new_user_type)
      let filteredArray = salesUsersList
      if(searchFilter){
        filteredArray = filteredArray.filter(item => item.label.toLowerCase().includes(searchFilter))
      }
      if(+new_user_type){
        filteredArray = filteredArray.filter(item => +item.new_user_type === +new_user_type)
      }
      setTempSalesUsersList(filteredArray)
      setFilterActiveLetters([...new Set(
        filteredArray.map((item) => {
          return item?.label[0]?.toUpperCase()
        }
        ).sort()
      )])
    } catch (error) {
      console.error("Error @ handleNewUsrTypChange", error)
    }
  }

  const closeUsersFilter = () => {
      try {
        if (selectedList.length === 0) { Toast("error", "Select Atleast a User") }
        else { setSalesPerson_id(selectedList[0].value); setShowUsersFilter(false) }
      } catch (error) {
        console.error("Error @ closeUsersFilter", error)
      }
    }

  return (
    <div className="perf">
      <div className="perf-header">
        <div>
          <h1 className="perf-title">Monthly Performance</h1>
          <p className="perf-subtitle">Year-on-year progression by month · values in ₹ Lakhs</p>
        </div>
        <div className="perf-legend">
          <span><i className="cur"></i>{currentYear}</span>
          <span><i className="prev"></i>{previousYear}</span>
        </div>
      </div>

      <div className="perf-controls">
        {salesUsersList?.length > 1 ? (
          <div className="select-sales-users" onClick={() => { setShowUsersFilter(true) }}>
            Select Users
          </div>
        ) : null}
        <SlTabGroup>
          {!(salesUsersList?.length > 1) && (
            <SlTab onClick={() => { salesTabChange(-1); }} slot="nav" panel="general" active={salesPerson_id === -1}>
              {localStorage.getItem("name")}
            </SlTab>
          )}
          {selectedList.map((item) => (
            <SlTab
              slot="nav"
              closable={selectedList.length > 1}
              onSlClose={() => handleRemove(item.value)}
              panel={item.value}
              onClick={() => { salesTabChange(item.value); }}
              active={salesPerson_id === item.value}
              id={`${item.value}`}
            >
              {item.label}
            </SlTab>
          ))}
        </SlTabGroup>
      </div>

      {loader ? (
        <div className="perf-loading">
          <div className="spinner-border text-primary" role="status">
            <span className="visually-hidden">Loading...</span>
          </div>
        </div>
      ) : currentyearPerfomance?.length ? (
        <div className="perf-grid">
          {currentyearPerfomance.map((item, index) => {
            const cur = item || {};
            const prev = previousyearPerfomance[index] || {};
            const curSpent = parseFloat(cur.spent) || 0;
            const prevSpent = parseFloat(prev.spent) || 0;
            const hasData = curSpent > 0;
            const trendPct = hasData ? (prevSpent > 0 ? ((curSpent - prevSpent) / prevSpent) * 100 : 100) : null;
            const aov = (o) => formatAmount((parseFloat(o?.order_value) || 0) / (parseInt(o?.order_count) || 1));
            const pctClass = (p) => {
              const n = parseFloat(p);
              if (!n) return "perf-pct--zero";
              if (n < 50) return "perf-pct--low";
              if (n < 100) return "perf-pct--mid";
              return "perf-pct--high";
            };
            const curPct = calculatePercentage(cur.total_target, cur.spent);
            const prevPct = calculatePercentage(prev.total_target, prev.spent);
            const rows = [
              { label: "Achieved %", cur: `${curPct}%`, prev: `${prevPct}%`, curCls: pctClass(curPct), prevCls: pctClass(prevPct) },
              { label: "Total Target", cur: `₹${formatAmount(cur.total_target)}`, prev: `₹${formatAmount(prev.total_target)}` },
              { label: "AOV", cur: `₹${aov(cur)}`, prev: `₹${aov(prev)}` },
              { label: "Campaigns", cur: cur.w2n_count ?? "–", prev: prev.w2n_count ?? "–" },
              { label: "Missing", cur: Math.max(parseInt(cur.missed || 0), 0), prev: Math.max(parseInt(prev.missed || 0), 0) },
              { label: "Known", cur: cur.known ?? "–", prev: prev.known ?? "–" },
              { label: "Unknown", cur: cur.unknown ?? "–", prev: prev.unknown ?? "–" },
              { label: "Interact. S/H", cur: `${cur.soft || 0} / ${cur.hard || 0}`, prev: `${prev.soft || 0} / ${prev.hard || 0}` },
            ];
            return (
              <div className="perf-card" key={cur.month || index}>
                <div className="perf-card-head">
                  <span className="perf-month">{cur.month}</span>
                  {hasData ? (
                    <span className={`perf-trend ${trendPct >= 0 ? "up" : "down"}`}>
                      <SlIcon library="lucide" name={trendPct >= 0 ? "trending-up" : "trending-down"}></SlIcon>
                      {trendPct >= 0 ? "+" : ""}{Math.round(trendPct)}%
                    </span>
                  ) : (
                    <span className="perf-trend none">
                      <SlIcon library="lucide" name="minus"></SlIcon>No data
                    </span>
                  )}
                </div>

                <div className="perf-achieved">
                  <div>
                    <div className="perf-ach-label perf-ach-label--cur">{currentYear} Achieved</div>
                    <div className="perf-ach-val">₹{formatAmount(cur.spent)}</div>
                  </div>
                  <div>
                    <div className="perf-ach-label">{previousYear} Achieved</div>
                    <div className="perf-ach-val perf-ach-val--prev">₹{formatAmount(prev.spent)}</div>
                  </div>
                </div>

                <div className="perf-metrics">
                  <div className="perf-metric perf-metric--head">
                    <span></span>
                    <span className="perf-yr perf-yr--cur">{currentYear}</span>
                    <span className="perf-yr perf-yr--prev">{previousYear}</span>
                  </div>
                  {rows.map((r) => (
                    <div className="perf-metric" key={r.label}>
                      <span className="perf-label">{r.label}</span>
                      <span className={`perf-v-cur ${r.curCls || ""}`}>{r.cur}</span>
                      <span className={`perf-v-prev ${r.prevCls || ""}`}>{r.prev}</span>
                    </div>
                  ))}
                </div>
              </div>
            );
          })}
        </div>
      ) : (
        <div className="perf-empty">No performance data</div>
      )}
      {showUsersFilter ? <div className="usersMultiSelect" onClick={() => closeUsersFilter()}>
        <div class="popupuserlist" onClick={(e) => e.stopPropagation()}>
          <div class="userlist-header">
            <div class="alphabiticals">
              <ul>
                {alphabets.map(alphabet => {
                  return <li
                    onClick={() => scrollToSection(alphabet)}
                    className={`${filterActiveLetters.includes(alphabet) ? "" : "inactive"
                      }`}

                  >
                    {alphabet}
                  </li>
                })}

              </ul>
            </div>
            <ul class="new-user-type">
              <li key={0} onClick={() => { handleNewUsrTypChange(0) }}>
                <label className={+newUserTypeInfilter === 0 ? 'active' : ''} onClick={() => handleNewUsrTypChange(0)}>
                  All
                </label>
              </li>
              {BrandsTypes.filter(item => allowedNewUserTypes.includes(item.value)).map((item) => (
                <li key={item.value} onClick={() => { handleNewUsrTypChange(item.value) }}>
                  <label className={+newUserTypeInfilter === item.value ? 'active' : ''} onClick={() => handleNewUsrTypChange(item.value)}>
                    {item.label}
                  </label>
                </li>
              ))}
            </ul>
            <div class="searchbox">
              <input class="form-control" placeholder="search" value={searchFilter} onChange={(e) => {
                setSearchFilter(e.target.value)
                let tempString = e.target.value.toLowerCase()
                let filteredArray = salesUsersList
                if (newUserTypeInfilter) {
                  filteredArray = filteredArray.filter(item => item.new_user_type === newUserTypeInfilter)
                }
                if (tempString) {
                  filteredArray = filteredArray.filter(item => item.label.toLowerCase().includes(tempString))
                  setTempSalesUsersList(filteredArray)
                  setFilterActiveLetters([...new Set(
                    filteredArray.map((item) => {
                      return item?.label[0]?.toUpperCase()
                    }
                    ).sort()
                  )])
                }
                else {
                  setTempSalesUsersList(filteredArray)
                  setFilterActiveLetters([...new Set(
                    salesUsersList.map((item) => {
                      return item?.label[0]?.toUpperCase()
                    }
                    ).sort()
                  )])
                }
              }}
              />
            </div>
          </div>

          <div class="userlistbody">
            {filterActiveLetters.map(alphabet => {
              let filteredUsers = tempSalesUsersList.filter(item => item.label[0].toUpperCase() === alphabet)
              return (<div class="alphabiticalletterelement">
                <div class="alphabiticalletter" id={alphabet}>
                  <span>{alphabet}</span>
                </div>

                <div class="userlist">
                  <ul>
                    {filteredUsers.map(user =>
                      <li onClick={() => { if (!selectedList.find(item => item.value === user.value)) { setSelectedList([...selectedList, user]); localStorage.setItem("selectedSalesList", JSON.stringify([...selectedList.map(item => item.value), user.value])) } else { setSelectedList([...selectedList.filter(item => item.value !== user.value)]); localStorage.setItem("selectedSalesList", JSON.stringify([...selectedList.filter(item => item.value !== user.value)].map(item => item.value))) } }} className={selectedList.find(item => item.value === user.value) ? "active" : ""}>
                        {user.label}
                      </li>)}
                  </ul>
                </div>
              </div>)

            }
            )}
          </div>

          <div class="userlistfooter">
            <div class="btnuserdetails">
              <button class="selectall" type="button" onClick={() => { setSelectedList([]); localStorage.setItem('selectedSalesList', JSON.stringify([])) }}>Clear All</button>
              <button class="selectonebyone" type="button" onClick={() => { setSelectedList([...new Set(salesUsersList.filter(item => [...selectedList.map(item => item.value), ...tempSalesUsersList.map(item => item.value)].includes(item.value)))]); localStorage.setItem("selectedSalesList", JSON.stringify([...new Set(salesUsersList.filter(item => [...selectedList.map(item => item.value), ...tempSalesUsersList.map(item => item.value)].includes(item.value)))].map(item => item.value))) }}>Select All</button>
              <button class={`selectonebyone ${selectedList.length === 0 ? 'disabled' : ''}`} type="button" title={selectedList.length === 0 ? 'Select Atleast a User' : ''} onClick={() => closeUsersFilter()}>Apply</button>
            </div>
          </div>
          <button
            className="close-btn"
            onClick={() => closeUsersFilter()}
          >
            <img src={closeSvg} alt="close2" />
          </button>
        </div>
      </div> : null}
    </div>
  );
}

export default MyPerfomance;
